import React, { createContext, useContext, useState } from 'react';

import { useFirebase } from './Firebase';
import { push, set, remove } from '../helpers/Firebase/base';
import { useAuth } from './Authentication';

const ItemContext = createContext(null);

const useItem = () => useContext(ItemContext);

const ItemProvider = ({ children }) => {
  const firebase = useFirebase();
  const { name } = useAuth();

  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState('');
  const [id, setId] = useState('');
  const [link, setLink] = useState('');
  const [title, setTitle] = useState('');


  const openDialog = () => {
    setEdit(false);
    setDescription('');
    setLink('');
    setTitle('');
    setOpen(true);
  };

  const openEdit = (item) => {
    setItem(item);
    setEdit(true);
    setOpen(true);
  };

  const save = () => {
    setLoading(true);
    setError(false);
    const listRef = firebase.list(name);
    const newItemRef = push(listRef);
    return set(newItemRef, {
      title,
      description,
      link,
    }).catch(() => setError(true)).then(() => setLoading(false));
  };

  const deleteItem = (id) => {
    setLoading(true);
    const itemRef = firebase.item(name, id);
    remove(itemRef).then(() => setLoading(false));
  };

  const update = () => {
    setLoading(true);
    setError(false);
    const itemRef = firebase.item(name, id);
    return set(itemRef, {
      title,
      description,
      link,
    }).catch(() => setError(true)).then(() => setLoading(false));
  };

  const setItem = (item) => {
    setId(item.id);
    setTitle(item.title);
    setDescription(item.description);
    setLink(item.link);
  };

  return (
    <ItemContext.Provider
      value={{
        description,
        deleteItem,
        edit,
        error,
        id,
        link,
        title,
        loading,
        open,
        openEdit,
        openDialog,
        save,
        setDescription,
        setEdit,
        setError,
        setId,
        setItem,
        setLink,
        setOpen,
        setTitle,
        setLoading,
        update,
      }}>
      {children}
    </ItemContext.Provider>
  )
};

export { ItemContext, ItemProvider, useItem };